<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="drawer"
    app
    :style="styles"
    :width="!!RouteHasChildren > 0 ? 358 : 78"
    class="py-3 d-print-none"
  >
    <div class="d-flex" style="height:100%;">
      <div
        class="d-flex grow-shrink-0 flex-grow-0"
        style="min-width:78px;flex-direction:column;"
      >
        <div
          class="d-flex  flex-grow-1 flex-shrink-0"
          style="flex-direction:column;"
        >
          <div class="text-center mt-8">
            <v-img
              class="d-inline-block"
              width="30"
              contain
              position="center center"
              src="@/assets/logo_white.png"
            />
          </div>
          <v-list nav class="mt-7 px-4" dark>
            <v-tooltip
              right
              v-for="(link, i) in links.filter(l =>
                l.isAllowed !== undefined ? l.isAllowed(this) : true
              )"
              :key="i"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-list-item
                  class="py- justify-center"
                  :to="link.to"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>{{ link.icon }}</v-icon>
                </v-list-item>
              </template>
              <span>{{ link.title }}</span>
            </v-tooltip>
          </v-list>
        </div>
        <div class="d-flex flex-shrink-1" style="flex-direction:column;">
          <v-list nav dark class="px-4">
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-list-item
                  class=" justify-center"
                  to="/notifications"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-badge
                    offset-x="10"
                    offset-y="10"
                    color="pink"
                    dot
                    large
                    :value="$store.getters.unreadNotificationsCount"
                  >
                    <v-icon>mdi-bell-outline</v-icon>
                  </v-badge>
                </v-list-item>
              </template>
              <span
                >You have
                {{ $store.getters.unreadNotificationsCount }}
                unread notifications</span
              >
            </v-tooltip>
            <v-tooltip right v-for="(link, i) in bottomLinks" :key="i">
              <template v-slot:activator="{ on, attrs }">
                <v-list-item
                  class="py- justify-center"
                  :to="link.to"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>{{ link.icon }}</v-icon>
                </v-list-item>
              </template>
              <span>{{ link.title }}</span>
            </v-tooltip>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-list-item
                  class="pa-0 justify-center"
                  to="/profile"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-account</v-icon>
                </v-list-item>
              </template>
              <span>My account</span>
            </v-tooltip>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-list-item
                  class="pa-0 justify-center"
                  @click="handleLogout"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-logout</v-icon>
                </v-list-item>
              </template>
              <span>Sign out</span>
            </v-tooltip>
          </v-list>
        </div>
      </div>

      <v-slide-x-transition
        mode="in-out"
        class="d-flex"
        v-if="!!RouteHasChildren"
      >
        <drawer-2nd
          class="fill-width"
          :parent="RouteHasChildren"
          :links="RouteHasChildren.children"
        />
      </v-slide-x-transition>
    </div>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import { AccountService } from "@/services"
import { DRAWER_LINKS, BOTTOM_DRAWER_LINKS } from "@/utils/links"
import { mapMutations, mapState } from "vuex"
import Drawer2nd from "./Drawer2nd.vue"

const getFirstRoute = str => str.split("/").filter(o => o !== "")[0] || null

export default {
  components: { Drawer2nd },
  props: {
    opened: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    links: DRAWER_LINKS,
    bottomLinks: BOTTOM_DRAWER_LINKS
  }),
  methods: {
    ...mapMutations("app", ["setMainDrawer", "setSecondaryDrawer"]),
    handleReturnToAdmin() {},
    handleLogout() {
      AccountService.logout()
    }
  },
  mounted() {},
  watch: {
    RouteHasChildren(vo, vn) {
      if (!!vn > 0 && !this.$store.state.app.drawer.secondary)
        this.setSecondaryDrawer(true)
      if (!!vn <= 0 && this.$store.state.app.drawer.secondary)
        this.setSecondaryDrawer(false)
    }
  },
  computed: {
    RouteHasChildren() {
      const r = [...this.bottomLinks, ...this.links].find(
        l =>
          !["", "/"].includes(l.to) &&
          !!l.children &&
          (
            (getFirstRoute(l.to) === getFirstRoute(this.$route.path) &&
              this.$route.path.indexOf(l.to) >= 0) ||
            l.children.some(child => child.to === this.$route.path)
          )
      )
      return r
    },
    styles() {
      return {
        "z-index": 7,
        background: "#ffffff",
        boxShadow: "0 0 2rem 0 rgba(136,152,170,.15)"
      }
    },
    ...mapState("app", ["image", "color"]),
    drawer: {
      get() {
        return this.$store.state.app.drawer.main
      },
      set(val) {
        this.setMainDrawer(val)
      }
    }
  }
}
</script>
<style>
.fill-width {
  width: 100%;
}
#app-drawer {
  width: 111.56px;
  height: 1080px;
  padding: 0px !important;

  background-color: #ff505c !important;
}
.theme--light.v-list {
  color: #bb3e3e;
}
</style>
